// src/pages/Home/Home.js
import React, { useMemo, useState } from "react";
import Hero from "../../sections/Hero";
import ProjectsStrip from "../../sections/ProjectsStrip";
import About from "../../sections/About";
import IntroOverlay from "../../components/IntroOverlay/IntroOverlay";
import logo from "../../assets/logo.png";
import Contact from "../../sections/Contact";
import Footer from "../../sections/Footer";
import logoWhite from "../../assets/logo-white.png";

export default function Home() {
  const INTRO_FLAG = useMemo(() => "__intro_seen_v1__", []);

  const [showIntro, setShowIntro] = useState(() => {
    try {
      return !window.name.includes(INTRO_FLAG);
    } catch {
      return true;
    }
  });

  const handleDone = () => {
    try {
      if (!window.name.includes(INTRO_FLAG)) {
        window.name = `${window.name || ""}${INTRO_FLAG}`;
      }
    } catch {}
    setShowIntro(false);
  };

  return (
    <main>
      {showIntro && (
        <IntroOverlay
          logoSrc={logo}
          onDone={handleDone}
          durationMs={1600} // tweak if you want slower
        />
      )}

      <section id="home">
        <Hero />
      </section>
      <ProjectsStrip />
      <About />
      <Contact />
      <Footer logoWhiteSrc={logoWhite} />
    </main>
  );
}
